import { render, staticRenderFns } from "./SithMesInventoryDn400DeliveryTaskList.vue?vue&type=template&id=4dd887f4&"
import script from "./SithMesInventoryDn400DeliveryTaskList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryDn400DeliveryTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports